import { LoadState } from "../../constants/enums";
import { IEvent, IEventState } from "./event.types";

export const initialEvent: IEvent = {
  event_uuid: null,
  master_event_uuid: null,
  event_name: "",
  event_description: "",
  status: "ACTIVE",
  company_outlet_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: null,
  insert_ts: "",
};

export const initialEventState: IEventState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  event: {
    data: initialEvent,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
